<template>
  <div>
    <div class="date-box p-3">
      <div class="spcore-big-text mb-2">{{ value.text }}</div>

      <div class="hvh-flex align-top">
        <div class="grow-1 hvh-flex mt-2">
          <div class="details grow-1 mr-1" v-for="(item, ind) in value.items" :key="ind">
            <div class="color-box" :style="{ backgroundColor: percentColor(item.value) }" />
            <div class="uppercase mt-2">{{ item.data.text }}</div>
            <div class="mt-1" v-for="(dataItem, ind) in item.data.items" :key="ind">
              <SPCorePercentageCircle class="percent-circle" :value="dataItem.value.replace('%', '')" />
              {{ dataItem.text }} {{ dataItem.value }}
            </div>
          </div>
        </div>
        <SPCorePercentageSchell class="ml-1 spcore-middle-text" :value="value.value" />
      </div>
    </div>
  </div>
</template>

<script>
import { percentColor } from '../../libraries/spcore'
import SPCorePercentageCircle from './SPCorePercentageCircle.vue'
import SPCorePercentageSchell from './SPCorePercentageSchell.vue'
export default {
  components: { SPCorePercentageSchell, SPCorePercentageCircle },
  props: ['value'],
  methods: {
    percentColor,
  },
}
</script>

<style lang="scss" scoped>
.date-box {
  border: 1px solid #c6e6e5;
}

.details {
  font-size: 10px;
  .color-box {
    height: 20px;
  }
  &:first-child {
    .color-box {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
  }

  &:last-child {
    .color-box {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
}

.percent-circle {
  width: 9px;
  height: 9px;
}
</style>